export const SET_CONVERSATION_SELECTED = 'SET_CONVERSATION_SELECTED'
export const SET_CONVERSATION_CONTENT_LOADING = 'SET_CONVERSATION_CONTENT_LOADING'
export const SET_CONVERSATION_PAGE = 'SET_CONVERSATION_PAGE'
export const SET_CONVERSATION_RECORD_PER_PAGE = 'SET_CONVERSATION_RECORD_PER_PAGE'
export const SET_CONVERSATION_TYPE = 'SET_CONVERSATION_TYPE'
export const FETCH_CONVERSATIONS = 'FETCH_CONVERSATIONS'
export const FETCH_CONVERSATIONS_SUCCESS = 'FETCH_CONVERSATIONS_SUCCESS'
export const FETCH_CONVERSATIONS_FAILED = 'FETCH_CONVERSATIONS_FAILED'
export const FETCH_APPEND_CONVERSATIONS = 'FETCH_APPEND_CONVERSATIONS'
export const FETCH_APPEND_CONVERSATIONS_SUCCESS = 'FETCH_APPEND_CONVERSATIONS_SUCCESS'
export const FETCH_APPEND_CONVERSATIONS_FAILED = 'FETCH_APPEND_CONVERSATIONS_FAILED'
export const RESET_CONVERSATIONS = 'RESET_CONVERSATIONS'
export const SET_CONVERSATIONS_LOADING = 'SET_CONVERSATIONS_LOADING'
export const REFETCH_MESSAGE = 'REFETCH_MESSAGE'
